/* jshint esnext: true */
import AbstractModule from './AbstractModule';

import {resizeApi} from '../utils/resize';

export default class extends AbstractModule {
    constructor(options) {
        super(options);
        this.isInitialized  = false;
        this.skrollrOptions = {
            forceHeight: false
        };
        this.deviceSupported = !((/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera));
        this.$document.on('refreshSkrollr.Parallax', (event) => {
            this.refreshSkrollr();
        })
        this.resizeIdent = resizeApi({
            action  : 'addCallback',
            callback: () => {
                // this.instance = this.manageSkrollr();
                this.onResize();
            }
        });
        setTimeout(() => {
            this.refreshSkrollr();
        }, 1000);
    }

    /**
     * Destroy the Skrollr singleton/instance
     * @return {void}
     */
    destroySkrollr() {
        if (this.isInitialized) {
            skrollr.init().destroy();
            this.isInitialized = false;
        }
    }

    canRenderSkrollr() {
        return window.matchMedia('(min-width: 1024px)').matches && this.deviceSupported;
    }

    /**
     * Reinitialize Skrollr on window size change
     * @return {Boolean|Object} Either false or the Skrollr singleton/instance
     */
    onResize() {
        if (this.canRenderSkrollr()) {
            if (!this.isInitialized) {
                this.refreshSkrollr()
            }
        } else {
            this.destroySkrollr();
        }
    }

    refreshSkrollr() {
        if (this.canRenderSkrollr()) {
            if (this.isInitialized) {
                skrollr.init().destroy();
            }
            skrollr.init(this.skrollrOptions);
            this.isInitialized = true;
        }
    }

    destroy() {
        resizeApi({
            'action': 'removeCallback',
            'ident' : this.resizeIdent
        });
        this.$document.off('.Parallax');
        this.destroySkrollr();
    }
}
